export default __webpack_public_path__ + "static/media/20_footer_salesOrder.95429f30.png";